module.exports = __webpack_public_path__ + "img/client4.f1116183.webp";